import React, { useEffect } from "react";
import profile_Img from "../../../../../../../Assets/Images/multipleUsers.png";
import { useDispatch, useSelector } from "react-redux";
import { decryptText } from "../../../../../../../Components/EncryptDecryptMessage/EncryptDecryptMessage";
import { converId } from "../../../../../../../Redux/slices/ChatSlice";
import { useLocation } from "react-router-dom";
import clsx from "clsx";
const GroupUserList = ({
  key,
  chat,
  moreNewChat,
  groupActiveChat,
  setGroupActiveChat,
  setChatConversationId,
  setGetSecretKey,
  setActiveSection,
  setIsMessageLoading,
  setShowProfileView,
}) => {
  const { socket } = useSelector((state) => state.socket);
  const { userInfo } = useSelector((state) => state.authUser);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (location?.state?.groupId === chat._id) {
      setIsMessageLoading(true);
      getSecretKeyFunction();
      dispatch(converId(chat?.conversationId?._id));
      setGroupActiveChat(chat);
      setChatConversationId((prev) => {
        if (prev?._id) {
          handleChatChangeConversation(prev._id);
        }
        joinConversation(chat?.conversationId?._id);
        return chat?.conversationId;
      });
      setActiveSection("contact");
    }
  }, [location]);

  const getSecretKeyFunction = async () => {
    const getKey = await decryptText(
      chat?.conversationId?.AESKeyOfUser,
      userInfo?.encryptedPrivateKey
    );
    setGetSecretKey(getKey);
  };
  const joinConversation = (conversationId) => {
    socket.emit("joinConversation", { id: conversationId });
  };
  const handleChatChangeConversation = async (conversationId) => {
    socket.emit("disconnectConversation", { id: conversationId });
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const today = new Date();

    if (date.toDateString() === today.toDateString()) {
      // show time
      return date.toLocaleString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } else {
      // return date in MM-DD-YYYY format
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    }
  };

  // Fix: Ensure proper ID comparison (convert to strings)
  const isActive = !moreNewChat && String(chat?._id) === String(groupActiveChat?._id);

  return (
    <li
      onClick={() => {
        if (chat?._id === groupActiveChat?._id) {
          return;
        }
        setShowProfileView(false);
        setIsMessageLoading(true);
        getSecretKeyFunction();
        dispatch(converId(chat?.conversationId?._id));
        setGroupActiveChat(chat);
        setChatConversationId((prev) => {
          if (prev?._id) {
            handleChatChangeConversation(prev._id);
          }
          joinConversation(chat?.conversationId?._id);
          return chat?.conversationId;
        });
        setActiveSection("contact");
      }}
      className={`relative mb-3 p-4 rounded-xl border transition-all cursor-pointer group ${isActive
        ? "bg-indigo-600 text-white border-slate-700 shadow-lg"
        : "bg-white dark:bg-slate-900 border-zinc-100 dark:border-slate-800 shadow-sm hover:shadow-md hover:border-zinc-200 dark:hover:border-slate-700"
        }`}
      key={key}
    >
      {/* Avatar + Content */}
      <div className="flex items-start gap-3">
        {chat?.mediaId?.imageUrl ? (
          <img
            src={chat.mediaId.imageUrl}
            alt={chat.groupName}
            className="w-12 h-12 rounded-2xl object-cover shadow-sm shrink-0"
          />
        ) : (
          <div
            className="w-12 h-12 flex items-center justify-center rounded-2xl shadow-sm shrink-0"
            style={{
              background: "linear-gradient(to bottom right, rgb(139 92 246), rgb(217 70 239))",
            }}
          >
            <span className="text-white font-bold text-lg">
              {chat.groupName
                ? chat.groupName
                  .split(" ")
                  .map((word) => word[0])
                  .join("")
                  .toUpperCase()
                  .slice(0, 2)
                : "#"}
            </span>
          </div>
        )}

        <div className="flex-1 min-w-0">
          {/* Name + Time */}
          <div className="flex items-baseline justify-between mb-1">
            <h3
              className={`font-semibold text-[15px] truncate max-w-[240px] ${isActive ? "text-white" : "text-black dark:text-white"
                }`}
            >
              {chat?.groupName}
            </h3>
            {chat?.latestMessage?.sentTime && (
              <span
                className={`text-xs shrink-0 ml-2 ${isActive ? "text-zinc-300" : "text-zinc-500 dark:text-zinc-400"
                  }`}
              >      {formatDate(chat?.latestMessage?.sentTime)}
              </span>
            )}
          </div>

          {/* Last Message + Badge */}
          <div className="flex items-center justify-between">
            <p
              className={`text-sm truncate ${isActive ? "text-zinc-200" : "text-gray-600 dark:text-gray-400"
                }`}
            >
              {chat?.latestMessage?.messageType === "LOCATION"
                ? "📍 Location"
                : chat?.latestMessage?.cipherText
                  ? chat?.latestMessage?.cipherText
                  : chat?.latestMessage?.fileType ||
                  chat?.latestMessage?.mediaId?.fileType ||
                  "No messages yet"}
            </p>

            {/* Unseen Badge */}
            {chat.unseenMessageCount > 0 && (
              <span className={`ml-2 text-[10px] font-semibold rounded-full h-5 min-w-5 px-1.5 flex items-center justify-center shadow-sm ${isActive ? "bg-white text-[#2e2e2e]" : "bg-indigo-600 text-white"
                }`}>
                {chat.unseenMessageCount > 99 ? "99+" : chat.unseenMessageCount}
              </span>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

export default GroupUserList;
